var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SvgVFlowerWilted = function (_a) {
    var title = _a.title, titleId = _a.titleId, desc = _a.desc, descId = _a.descId, props = __rest(_a, ["title", "titleId", "desc", "descId"]);
    return (_jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId }, props, { children: [desc ? _jsx("desc", __assign({ id: descId }, { children: desc })) : null, title ? _jsx("title", __assign({ id: titleId }, { children: title })) : null, _jsx("path", { d: "M9 5a5 5 0 0 1 9.916-.916A5.002 5.002 0 0 1 23 9v4a1 1 0 0 1-1.6.8L20 12.75l-1.4 1.05a1 1 0 0 1-1.2 0L16 12.75l-1.4 1.05A1 1 0 0 1 13 13V9a5.002 5.002 0 0 1 3.871-4.872A3.001 3.001 0 0 0 11 5V18.948A7 7 0 0 1 16.708 16H18a1 1 0 0 1 .986 1.164l-.164.987A7 7 0 0 1 11.917 24H10a.998.998 0 0 1-1-1v-.002M18 6a3 3 0 0 0-3 3v2l.4-.3a1 1 0 0 1 1.2 0l1.4 1.05 1.4-1.05a1 1 0 0 1 1.2 0l.4.3V9a3 3 0 0 0-3-3Zm-5.764 14.764L11.618 22h.3a5 5 0 0 0 4.898-4h-.108a5 5 0 0 0-4.472 2.764Z", fill: "currentColor" }), _jsx("path", { d: "M9 10.948A7 7 0 0 0 3.292 8H2a1 1 0 0 0-.986 1.164l.164.987A7 7 0 0 0 8.083 16H9v6.998M8.083 14a5 5 0 0 1-4.9-4h.109a5 5 0 0 1 4.472 2.764L8.382 14h-.3ZM9 5v5.948Z", fill: "currentColor" })] })));
};
export default SvgVFlowerWilted;
